import React from 'react';

const Main = ({activeNote, updateNote}) => {
    const fieldEditHandler = (field, value)=>{
        updateNote({
            ...activeNote,
            [field]: value,
            lastModified: Date.now()
        })
    }

    if (!activeNote) return <div className="no-active-note">No note selected.</div>

    return (
        <div className="app-main">
            <div className="app-main-note-edit">
                <input
                    type="text"
                    id="title"
                    onChange={(e)=>fieldEditHandler("title", e.target.value)}
                    value={activeNote.title} autoFocus
                />
                <textarea
                    id="body"
                    placeholder="Write your note here. . ."
                    onChange={(e)=>fieldEditHandler("body", e.target.value)}
                    value={activeNote.body}
                />
            </div>
        </div>
    );
};

export default Main;